<template>
  <div>
    <el-dialog :title="$t('user81')" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialog.edit" width="25%" class="info-dialog">
      <el-form :model="formData" ref="formData" :rules="rules" class="form-data">
        <el-form-item prop="old_password">
          <el-input v-model="formData.old_password" :placeholder="$t('index31')"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="formData.password" :placeholder="$t('index32')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" type="primary" @click="submitForm('formData')">
          <I18Lang id="user84" defaultText="提交" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your new password')) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        callback()
      }
    }

    const validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your current password')) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        callback()
      }
    }

    return {
      dialog: {
        edit: false
      },
      formData: {
        password: '',
        old_password: ''
      },
      rules: {
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        old_password: [
          { required: true, validator: validateOldPass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    showDialog () { // 修改类型
      this.dialog.edit = true
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submitData () {
      this.$http.post('/api/user/editPassword', this.formData).then(result => {
        this.dialog.edit = false
        this.$emit('onUpdata')
        this.$alert(this.$t('public76'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
          }
        })
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 380px;
    height: 380px;
    background: url("../../../../assets/img/user/short-bg.png") no-repeat center / 100% 100%;

    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }

    .form-item {
      margin-bottom: 35px;

      .form-item-label {
        font-size: 16px;
        font-weight: 400;
        color: #01B2F5;
        margin-bottom: 10px;
      }

      .form-item-value {
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: rgb(#FFFFFF, 0.6);
      }
    }
  }
}
</style>
